import { useState, useContext, useRef, useEffect } from "react";
import ExperienceContext from "./ExperienceContext";
import { useSelector } from "react-redux";
import {
	showSuccessNotification,
	showErrorNotification,
} from "../../utils/Notifications";
import {
	Text,
	Image,
	TextInput,
	Group,
	Button,
	Modal,
	Tabs,
	Input,
	Container,
	Grid,
	ScrollArea,
	Loader,
	Pagination,
} from "@mantine/core";
import uploadIcon from "../../static/svg/upload.svg";
import uploadMedia from "../../API/uploadMedia";
import { getAssets } from "../../API/getAssets";
import AudioIMG from "../../static/svg/audio.svg";
function AudioSpotModal({ isAudioSpotOpen, setIsAudioSpotOpen, activePanoId }) {
	const user = useSelector((state) => state.userInformationReducer.users);
	const { addNewAudioSpot } = useContext(ExperienceContext);
	const fileInput = useRef(null);
	const [uploadedFile, setUploadedFile] = useState(null);
	const [text, setText] = useState("");
	const [recentAudios, setRecentAudios] = useState("");
	const [pages, setPages] = useState(1);
	const [activePage, setPage] = useState(1);
	const [activeTab, setActiveTab] = useState("Upload");
	const handleFileUpload = (event) => {
		setUploadedFile(event.target.files[0]);
	};
	const [loading, setLoading] = useState(false);

	const handleCreate = async () => {
		setLoading(true);
		if (text === "") {
			showErrorNotification("Audio label cannot be empty");
			setLoading(false);
			return;
		} else if (!uploadedFile) {
			showErrorNotification("Please upload an Audio");
			setLoading(false);
			return;
		}
		const formData = new FormData();
		formData.append("myfile", uploadedFile);
		formData.append(
			"bodyData",
			JSON.stringify({
				UserId: user?.UserId,
				AccountId: user?.AccountId,
				Name: text,
				AssetTypeId: 2,
			})
		);
		const result = await uploadMedia(formData);
		if (result.status === 201) {
			addNewAudioSpot(activePanoId, result.data.res, text);
			showSuccessNotification("Audio uploaded");
		} else {
			showErrorNotification("Audio not uploaded");
		}
		setUploadedFile(null);
		setText("");
		setIsAudioSpotOpen(false);
		setLoading(false);
	};

	const addFromRecent = (audio) => {
		addNewAudioSpot(activePanoId, audio.LocationUrl, audio.Name);
		setUploadedFile(null);
		setText("");
		setIsAudioSpotOpen(false);
	};

	useEffect(() => {
		const recentMedia = async () => {
			const result = await getAssets(user?.UserId, activePage, 2, 10);
			setRecentAudios(result.data);
			setPages(result.totalPages);
		};
		recentMedia();
	}, [activePage]);

	return (
		<Modal
			centered
			size="lg"
			opened={isAudioSpotOpen}
			onClose={() => {
				setText("");
				setUploadedFile(null);
				setIsAudioSpotOpen(false);
			}}
			title="Add Audio Spot"
			styles={{
				modal: { backgroundColor: "#040F1F" },
				title: { color: "#ffffff", fontWeight: "700" },
			}}
		>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
			<Tabs
				value={activeTab}
				onTabChange={setActiveTab}
				style={{ borderBottom: "none !important" }}
				styles={{
					tabsListWrapper: { borderBottom: "none !important" },
					tabsList: { borderBottom: "none !important" },
				}}
			>
				<Tabs.List>
					<Tabs.Tab
						value="Upload"
						sx={{
							"&:hover": {
								backgroundColor: "inherit",
								borderBottom: "none",
							},
						}}
					>
						Upload{" "}
					</Tabs.Tab>
					<Tabs.Tab
						value="Recent"
						sx={{
							"&:hover": {
								backgroundColor: "inherit",
								borderBottom: "none",
							},
						}}
					>
						Recent
					</Tabs.Tab>
				</Tabs.List>
				<Tabs.Panel value="Upload" pt="xs">
					<Container style={{ width: "100%", minHeight: "300px" }}>
						<TextInput
							my={5}
							label="Audio label"
							variant="filled"
							placeholder="Enter audio description"
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
								label: {
									color: "#ffffff",
									fontWeight: "700",
								},
							}}
							value={text}
							onChange={(event) =>
								setText(event.currentTarget.value)
							}
						/>
						{uploadedFile === null ? (
							<>
								<label
									htmlFor="file-input"
									style={{
										display: "flex",
										width: "100%",
										height: "100%",
										minHeight: "300px",
										alignItems: "center",
										justifyContent: "center",
										flexDirection: "column",
										gap: "10px",
										border: "1px solid #09254E",
										borderRadius: "5px",
										cursor: "pointer",
									}}
								>
									<Image src={uploadIcon} width={75} />
									<Button
										variant="outline"
										my={10}
										px={30}
										size="xs"
										radius={"md"}
										sx={(theme) => ({
											color: theme.colors.white[0],
											borderColor:
												theme.colors.ivisit_light[0],
										})}
										onClick={() => {
											fileInput.current.click();
										}}
									>
										Browse
									</Button>
								</label>
								<Input
									id="file-input"
									ref={fileInput}
									type="file"
									accept=".mp3"
									variant="unstyled"
									styles={{
										wrapper: {
											display: "none",
										},
									}}
									onChange={handleFileUpload}
								/>
							</>
						) : (
							<audio controls>
								<source
									src={URL.createObjectURL(uploadedFile)}
									type="audio/mpeg"
								/>
								Your browser does not support the audio element.
							</audio>
						)}
					</Container>
				</Tabs.Panel>
				<Tabs.Panel value="Recent" pt="xs">
					Use recent Audios
					<ScrollArea
						mt={10}
						style={{ height: 300 }}
						type="auto"
						offsetScrollbars
						scrollbarSize={8}
						scrollHideDelay={500}
					>
						<Grid style={{ minHeight: 270 }}>
							{recentAudios &&
								recentAudios.map((item) => {
									return (
										<Grid.Col
											span={3}
											key={item.id}
											onClick={() => {
												addFromRecent(item);
											}}
										>
											<a
												style={{
													cursor: "pointer",
													display: "flex",
													flexDirection: "column",
												}}
											>
												<img
													alt="RecentImages"
													style={{
														width: "20%",
														height: "80px",
														margin: "auto",
													}}
													src={AudioIMG}
												/>
												<p
													style={{
														textAlign: "center",
														textOverflow:
															"ellipsis",
														whiteSpace: "nowrap",
														fontSize: "14px",
														marginTop: "3px",
														overflow: "hidden",
													}}
												>
													{`${item.Name}.mp4`}
												</p>
											</a>
										</Grid.Col>
									);
								})}
						</Grid>
						{pages !== 1 && (
							<Pagination
								sx={{
									Button: {
										background: "#09254E",
										fontWeight: "600",
										padding: "0px 4px",
										fontSize: "12px",
										border: "none",
									},
									"Button:first-child": {
										backgroundColor: "#14B8E1",
										border: "none",
									},
									"Button:last-child": {
										backgroundColor: "#14B8E1",
										border: "none",
									},
								}}
								page={activePage}
								onChange={setPage}
								mt={5}
								total={pages}
								size="xs"
								style={{
									justifyContent: "center",
									color: "pink",
								}}
							/>
						)}
					</ScrollArea>
				</Tabs.Panel>
			</Tabs>

			<Group
				style={{
					width: "100%",
					justifyContent: "space-between",
					marginBotom: "15px",
				}}
			>
				<Group
					style={{
						width: "auto",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						color: "#a4bac6",
						opacity: "0.5",
					}}
				>
					<Text
						size="xs"
						backgroundColor="red"
						color="white"
						style={{ lineHeight: "0px", marginTop: "15px" }}
					>
						{" "}
						Make sure your file size is under 3 MB.
					</Text>
					<Text size="xs" color="white" style={{ lineHeight: "0px" }}>
						Learn More about our platform supported formats and
						restrictions.
					</Text>
				</Group>
				<Group
					style={{
						width: "auto",
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<Button
						variant="outline"
						my={0}
						px={25}
						size="xs"
						radius={"md"}
						sx={(theme) => ({
							color: theme.colors.white[0],
							borderColor: theme.colors.ivisit_light[0],
						})}
						onClick={() => {
							setText("");
							setUploadedFile(null);
							setIsAudioSpotOpen(false);
						}}
					>
						Cancel
					</Button>
					<Button
						variant="outline"
						my={0}
						px={25}
						size="xs"
						radius={"md"}
						sx={(theme) => ({
							color: theme.colors.white[0],
							borderColor: theme.colors.ivisit_light[0],
						})}
						onClick={handleCreate}
					>
						Create
					</Button>
				</Group>
			</Group>
		</Modal>
	);
}

export default AudioSpotModal;
